import { CORPORATE_EDITORIAL } from "./editorial";

/**
* Corporate Formation & Company Services — data for /corporate/* cluster.
*
* Covers 20 entity/service types × 15 nationality contexts × 12 Bangkok
* business zones, plus the 400-keyword universe grouped by intent.
*
* Provider: Thai Notary Law & Service Co., Ltd.
 * Service scope is assessed from actual business activities.
 */

// ── Keyword universe (400 keywords grouped) ───────────────────────────────
export const CORPORATE_KEYWORD_GROUPS = [
  {
    id: "core",
    label: "คำหลัก / Core",
    keywords: [
      "จดทะเบียนบริษัท", "จดบริษัท", "รับจดทะเบียนบริษัท", "จดทะเบียนบริษัทจำกัด",
      "เปิดบริษัท", "ตั้งบริษัท", "จัดตั้งบริษัท", "จดบริษัทออนไลน์",
      "ขั้นตอนจดทะเบียนบริษัท", "เอกสารจดทะเบียนบริษัท", "ค่าจดทะเบียนบริษัท",
      "ราคาจดทะเบียนบริษัท", "จดทะเบียนบริษัทกรมพัฒนาธุรกิจการค้า", "DBD จดทะเบียนบริษัท",
      "รับจดบริษัทด่วน", "จดทะเบียนบริษัทครบวงจร", "one stop service จดบริษัท",
      "ทนายจดทะเบียนบริษัท", "สำนักงานจดทะเบียนบริษัท", "บริการจดทะเบียนบริษัท",
      "company registration thailand", "register company in thailand",
      "set up company thailand", "start business thailand", "incorporate thailand",
      "thai company registration", "form company thailand", "company formation thailand",
      "how to open company in thailand", "thailand company setup cost",
      "thailand company setup process", "company registration bangkok",
      "business registration thailand", "commercial registration thailand",
      "corporate services thailand", "corporate lawyer thailand",
      "business formation thailand", "start a company in bangkok",
    ],
  },
  {
    id: "entity",
    label: "ประเภทกิจการ / Entity types",
    keywords: [
      "จดทะเบียนบริษัทจำกัด", "จดทะเบียนห้างหุ้นส่วน", "จดทะเบียนห้างหุ้นส่วนจำกัด",
      "จดทะเบียนบริษัทมหาชน", "จดทะเบียนบริษัท limited", "จดทะเบียนบริษัทเอกชน",
      "จดสำนักงานสาขา", "จดทะเบียนสำนักงานตัวแทน", "จดทะเบียน representative office",
      "จดทะเบียน branch office", "จดทะเบียน regional office", "จดทะเบียนสำนักงานภูมิภาค",
      "private limited company thailand", "public limited company thailand",
      "partnership registration thailand", "limited partnership thailand",
      "sole proprietorship thailand", "ordinary partnership thailand",
      "register branch office thailand", "register representative office thailand",
      "register regional office thailand", "จดทะเบียน holding company",
      "holding company thailand", "จดทะเบียน trading company thailand",
      "trading company registration thailand", "manufacturing company thailand",
      "จดทะเบียน consulting company", "service company registration thailand",
      "จดทะเบียน e-commerce company", "e-commerce company thailand",
      "โฮลดิ้งคัมพะนี ประเทศไทย", "จดบริษัทจำกัด vs หจก", "ห้างหุ้นส่วนสามัญ",
      "จดทะเบียนมูลนิธิ", "จดทะเบียนสมาคม", "foundation registration thailand",
      "association registration thailand",
    ],
  },
  {
    id: "foreign",
    label: "นักลงทุนต่างชาติ / Foreign investors",
    keywords: [
      "ต่างชาติจดบริษัทในไทย", "จดบริษัทต่างชาติ", "foreign owned company thailand",
      "100 percent foreign owned company thailand", "foreigner start company thailand",
      "expat company registration thailand", "foreign business license thailand",
      "FBL thailand", "จดทะเบียน foreign business license", "ขอ FBL ไทย",
      "foreign business act thailand", "list 3 foreign business act",
      "US-Thai amity treaty", "amity treaty thailand company",
      "amity treaty registration bangkok", "japan thai company registration",
      "singapore company in thailand", "chinese company setup thailand",
      "korean investors thailand company", "german company registration bangkok",
      "australian owned company thailand", "uk company registration thailand",
      "france company thailand", "russian company thailand", "india company thailand",
      "จดบริษัทกับหุ้นส่วนต่างชาติ", "share ratio foreign thai", "nominee shareholder thailand",
      "hidden nominee thailand law", "nominee prohibited thailand",
      "thai majority shareholding", "foreign shareholder limit thailand",
      "work permit + company registration", "ทำ work permit ให้ต่างชาติ",
      "smart visa + company", "LTR visa + company thailand",
      "ต่างชาติเป็นกรรมการ", "foreigner as director thailand", "foreign director thailand company",
    ],
  },
  {
    id: "boi",
    label: "BOI / IEAT / Promotion",
    keywords: [
      "BOI thailand", "ขอบัตรส่งเสริม BOI", "ยื่นขอ BOI", "BOI application thailand",
      "board of investment thailand", "ทำเรื่อง BOI", "ที่ปรึกษา BOI",
      "BOI consultant thailand", "BOI incentive thailand", "สิทธิประโยชน์ BOI",
      "corporate tax exemption BOI", "yก+เว้นภาษีนิติบุคคล BOI",
      "software BOI thailand", "IT BOI thailand", "digital services BOI",
      "manufacturing BOI thailand", "R&D BOI thailand", "logistics BOI thailand",
      "IHQ ITC BOI", "international business center IBC thailand",
      "smart city BOI thailand", "EEC investment thailand",
      "eastern economic corridor incentive", "IEAT industrial estate thailand",
      "อีสเทิร์นซีบอร์ด BOI", "amata city BOI", "hemaraj BOI",
      "amata factory setup BOI", "renewable energy BOI thailand",
      "biotechnology BOI thailand", "high tech BOI thailand",
      "content industry BOI thailand", "digital park BOI", "medical hub BOI",
      "creative economy BOI", "BOI section 3 thailand",
      "BOI section 8 tax holiday", "BOI PTS visa work permit",
      "e-visa work permit BOI", "single window BOI",
    ],
  },
  {
    id: "post-reg",
    label: "หลังจดทะเบียน / Post-registration",
    keywords: [
      "ขอเลขผู้เสียภาษี", "ขอเลขประจำตัวผู้เสียภาษี", "ขอเลข TIN",
      "จด VAT", "จดภาษีมูลค่าเพิ่ม", "ขอ VAT registration thailand",
      "vat threshold thailand 1.8 million", "รับจด VAT ด่วน",
      "ประกันสังคม กองทุนเงินทดแทน", "social security registration thailand",
      "workmens compensation fund thailand", "SSO registration thailand",
      "ขอใบอนุญาตประกอบธุรกิจ", "จดพาณิชย์ อบต", "จดพาณิชย์เทศบาล",
      "open corporate bank account thailand", "corporate bank account bangkok",
      "kbank corporate account", "scb corporate account", "bbl corporate account",
      "krung thai corporate account", "certify signature for bank",
      "notarize corporate documents bank", "รับรองเอกสารเปิดบัญชี",
      "ขอ digital signature", "ThaID business", "e-signature company thailand",
      "ทะเบียนพาณิชย์อิเล็กทรอนิกส์", "DBD trustmark", "e-commerce registration DBD",
      "จดเครื่องหมายการค้าคู่บริษัท", "SEC application securities", "ก.ล.ต. company",
      "e-filing DBD annual", "จดผู้ประกอบการนำเข้าส่งออก", "customs importer/exporter",
      "จด paperless customs", "จดใบอนุญาตกรมโรงงาน",
    ],
  },
  {
    id: "changes",
    label: "แก้ไขข้อมูล / Corporate changes",
    keywords: [
      "แก้ไขบริษัท", "แก้ไขข้อมูลบริษัท", "เพิ่มทุนบริษัท", "ลดทุนบริษัท",
      "เพิ่มกรรมการบริษัท", "ถอนกรรมการบริษัท", "แต่งตั้งกรรมการใหม่",
      "ย้ายที่อยู่บริษัท", "เปลี่ยนชื่อบริษัท", "เปลี่ยนวัตถุประสงค์บริษัท",
      "แก้ไขวัตถุประสงค์บริษัท", "เพิ่มสาขาบริษัท", "เพิ่มวัตถุประสงค์บริษัท",
      "increase registered capital thailand", "decrease registered capital thailand",
      "add director thailand", "remove director thailand", "change director thailand",
      "change address thailand company", "change company name thailand",
      "add branch thailand", "change signatory bank thailand",
      "amend company objectives thailand", "corporate reorganization thailand",
      "การควบรวมบริษัท", "merger acquisition thailand", "M&A thailand",
      "amalgamation thailand", "share transfer thailand", "โอนหุ้นบริษัท",
      "เปลี่ยนแปลงผู้ถือหุ้น", "shareholder change thailand", "director change bangkok",
      "annual general meeting thailand", "ประชุมสามัญประจำปี", "AGM thailand",
      "special resolution thailand", "extraordinary general meeting",
      "certified copy of company documents", "รับรองสำเนาเอกสารบริษัท",
      "amend articles of association thailand", "แก้ไขหนังสือบริคณห์สนธิ",
    ],
  },
  {
    id: "shutdown",
    label: "เลิกบริษัท ชำระบัญชี / Wind-down",
    keywords: [
      "เลิกบริษัท", "ปิดบริษัท", "ชำระบัญชี", "รับจดเลิกบริษัท",
      "รับปิดบริษัท", "รับชำระบัญชี", "liquidation thailand",
      "close company thailand", "dissolve company thailand", "deregister company thailand",
      "wind up company thailand", "voluntary liquidation thailand",
      "compulsory liquidation thailand", "member voluntary liquidation thailand",
      "creditor liquidation thailand", "bankruptcy filing thailand",
      "insolvency thailand company", "strike off company thailand",
      "ล้มละลาย ทำอย่างไร", "ปิดบริษัทไม่จ่ายภาษี", "ปิดบริษัทค้างงบ",
      "จดปิด vat", "cancel vat registration thailand", "ยกเลิกจดทะเบียน vat",
      "cancel social security thailand", "ยกเลิกประกันสังคม",
      "close corporate bank account thailand", "closing balance sheet thailand",
      "liquidator thailand", "ผู้ชำระบัญชีบริษัท", "final tax return liquidation",
      "final financial statement liquidation", "audit for liquidation thailand",
      "publish notice in newspaper liquidation thailand",
      "ราชกิจจานุเบกษาเลิกบริษัท", "notify creditors liquidation thailand",
      "return TIN card thailand", "close branch office thailand",
      "close representative office thailand", "จดเลิกสำนักงานตัวแทน",
    ],
  },
  {
    id: "compliance",
    label: "Compliance / บัญชีภาษี",
    keywords: [
      "จัดทำบัญชีบริษัท", "รับทำบัญชีบริษัท", "outsource accounting bangkok",
      "monthly accounting service thailand", "งบการเงินบริษัท", "audit ผู้สอบบัญชี",
      "cpa thailand", "CPA license thailand", "TA tax auditor thailand",
      "ยื่นภาษี ภงด 50", "PND 50 thailand", "half-year corporate tax PND 51",
      "monthly VAT return PP30", "รับจด VAT รายเดือน", "withholding tax PND 3 53",
      "ยื่นภาษีหัก ณ ที่จ่าย", "ประกันสังคมรายเดือน", "monthly SSO thailand",
      "annual audit thailand", "audit small company thailand", "IFRS thailand",
      "TFRS SME thailand", "annual financial statement DBD", "e-filing dbd bahn",
      "corporate income tax 20 percent thailand", "SME tax rate thailand",
      "transfer pricing thailand", "TP disclosure form 200 million",
      "country by country report thailand", "CbCR thailand",
      "revenue department audit thailand", "sanctions AMLO",
      "beneficial ownership register thailand", "UBO reporting thailand",
      "AML/KYC company thailand", "PDPA compliance company thailand",
      "corporate governance thailand", "board of directors duty thailand",
      "shareholder register thailand",
    ],
  },
  {
    id: "location-price",
    label: "ทำเล ราคา ด่วน / Location, price, speed",
    keywords: [
      "จดบริษัทสีลม", "จดบริษัทสาทร", "จดบริษัทสุขุมวิท",
      "จดบริษัทอโศก", "จดบริษัทพหลโยธิน", "จดบริษัทรัชดา",
      "จดบริษัทลาดพร้าว", "จดบริษัทบางนา", "จดบริษัทพระราม 9",
      "จดบริษัทนนทบุรี", "จดบริษัทปทุมธานี", "จดบริษัทสมุทรปราการ",
      "จดบริษัทเชียงใหม่", "จดบริษัทภูเก็ต", "จดบริษัทพัทยา",
      "company registration silom", "company registration sathorn",
      "company registration sukhumvit", "company registration asoke",
      "company registration rama9", "company registration chiang mai",
      "company registration phuket", "จดบริษัทขอใบเสนอราคา", "เปรียบเทียบขอบเขตงานจดบริษัท",
      "จดบริษัท 5000 บาท", "จดบริษัท ฟรี", "ค่าจดบริษัทกี่บาท",
      "ค่าธรรมเนียม dbd จดบริษัท", "cost to register company thailand",
      "cheap company registration bangkok", "fast company registration thailand",
      "same day company registration thailand", "ด่วนจดบริษัท 1 วัน",
      "จดบริษัท 3 วัน", "จดบริษัทรับด่วน", "รับจดบริษัทด่วนพิเศษ",
      "จดบริษัทกี่วัน", "how long to register company thailand",
    ],
  },
] as const;

export const ALL_CORPORATE_KEYWORDS: string[] = CORPORATE_KEYWORD_GROUPS.flatMap(
  (g) => g.keywords as readonly string[],
);

// ── Service / entity types (20 canonical) ─────────────────────────────────
export type CorporateServiceCategory =
  | "entity"
  | "foreign"
  | "boi"
  | "post-reg"
  | "changes"
  | "shutdown"
  | "compliance"
  | "office";

export interface CorporateService {
  slug: string;
  nameTh: string;
  nameEn: string;
  category: CorporateServiceCategory;
  priceTHB: number; // starting service fee (excl. gov't fees)
  turnaroundDays: number; // typical delivery
  govFeeTHB?: number; // approximate DBD/BOI/gov fee, indicative
  keyDeliverables: string[];
  requiredDocs: string[];
  bestFor: string[];
  legalBasis: string; // primary statute
}

const SERVICE_IDENTITIES: Array<Pick<CorporateService, "slug" | "nameTh" | "nameEn" | "category">> = [
  {
    "slug": "private-limited-company",
    "nameTh": "จดทะเบียนบริษัทจำกัด (Private Limited)",
    "nameEn": "Private Limited Company Registration",
    "category": "entity"
  },
  {
    "slug": "limited-partnership",
    "nameTh": "จดทะเบียนห้างหุ้นส่วนจำกัด (LP)",
    "nameEn": "Limited Partnership Registration",
    "category": "entity"
  },
  {
    "slug": "public-limited-company",
    "nameTh": "จดทะเบียนบริษัทมหาชน (Public Limited)",
    "nameEn": "Public Limited Company Registration",
    "category": "entity"
  },
  {
    "slug": "branch-office",
    "nameTh": "จดทะเบียนสำนักงานสาขา (Branch Office)",
    "nameEn": "Branch Office Registration",
    "category": "office"
  },
  {
    "slug": "representative-office",
    "nameTh": "จดทะเบียนสำนักงานผู้แทน (Rep Office)",
    "nameEn": "Representative Office Registration",
    "category": "office"
  },
  {
    "slug": "regional-office",
    "nameTh": "จดทะเบียนสำนักงานภูมิภาค (Regional Office)",
    "nameEn": "Regional Office Registration",
    "category": "office"
  },
  {
    "slug": "amity-treaty-company",
    "nameTh": "บริษัท US-Thai Amity Treaty",
    "nameEn": "US Amity Treaty Company",
    "category": "foreign"
  },
  {
    "slug": "foreign-business-license",
    "nameTh": "ขอใบอนุญาต Foreign Business License (FBL)",
    "nameEn": "Foreign Business License Application",
    "category": "foreign"
  },
  {
    "slug": "boi-application",
    "nameTh": "ยื่นขอบัตรส่งเสริม BOI",
    "nameEn": "Board of Investment (BOI) Promotion",
    "category": "boi"
  },
  {
    "slug": "ibc-ihq",
    "nameTh": "จัดตั้ง International Business Center (IBC)",
    "nameEn": "International Business Center (IBC) Setup",
    "category": "boi"
  },
  {
    "slug": "vat-registration",
    "nameTh": "จดทะเบียนภาษีมูลค่าเพิ่ม (VAT)",
    "nameEn": "VAT Registration (Form Phor.Por.01)",
    "category": "post-reg"
  },
  {
    "slug": "social-security-registration",
    "nameTh": "จดทะเบียนประกันสังคม",
    "nameEn": "Social Security Fund Registration",
    "category": "post-reg"
  },
  {
    "slug": "corporate-bank-account",
    "nameTh": "เปิดบัญชีธนาคารนิติบุคคล",
    "nameEn": "Corporate Bank Account Opening",
    "category": "post-reg"
  },
  {
    "slug": "capital-increase",
    "nameTh": "เพิ่มทุนจดทะเบียน",
    "nameEn": "Registered Capital Increase",
    "category": "changes"
  },
  {
    "slug": "director-change",
    "nameTh": "เปลี่ยนแปลงกรรมการ",
    "nameEn": "Director Change / Board Restructure",
    "category": "changes"
  },
  {
    "slug": "share-transfer",
    "nameTh": "โอนหุ้นบริษัท",
    "nameEn": "Share Transfer",
    "category": "changes"
  },
  {
    "slug": "address-change",
    "nameTh": "ย้ายที่อยู่บริษัท",
    "nameEn": "Registered Address Change",
    "category": "changes"
  },
  {
    "slug": "voluntary-liquidation",
    "nameTh": "เลิกและชำระบัญชีบริษัทโดยสมัครใจ",
    "nameEn": "Voluntary Liquidation",
    "category": "shutdown"
  },
  {
    "slug": "annual-audit-filing",
    "nameTh": "audit งบการเงิน + ยื่น สบช.3 / ภ.ง.ด.50",
    "nameEn": "Annual Audit + DBD/RD Annual Filing",
    "category": "compliance"
  },
  {
    "slug": "corporate-secretary-retainer",
    "nameTh": "บริการเลขานุการบริษัท (retainer รายปี)",
    "nameEn": "Corporate Secretary Retainer",
    "category": "compliance"
  }
];

export const CORPORATE_SERVICES: CorporateService[] = SERVICE_IDENTITIES.map((identity) => {
 const entry = CORPORATE_EDITORIAL[identity.slug];
 if (!entry) throw new Error(`Missing corporate editorial: ${identity.slug}`);
 return { ...identity, priceTHB: 0, turnaroundDays: 0, keyDeliverables: entry.deliverables, requiredDocs: entry.documents, bestFor: [entry.decision], legalBasis: "ตรวจตามประเภทนิติบุคคล กิจกรรมและหลักเกณฑ์ของหน่วยงานที่เกี่ยวข้อง" };
});

export const CORPORATE_CATEGORIES = [
  { id: "entity", nameTh: "จดทะเบียนกิจการ", nameEn: "Entity Formation" },
  { id: "office", nameTh: "สาขา / สำนักงานตัวแทน / ภูมิภาค", nameEn: "Branch / Rep / Regional Office" },
  { id: "foreign", nameTh: "นักลงทุนต่างชาติ", nameEn: "Foreign Investors" },
  { id: "boi", nameTh: "BOI / IBC / EEC", nameEn: "BOI / IBC / EEC Promotion" },
  { id: "post-reg", nameTh: "หลังจดทะเบียน", nameEn: "Post-Registration" },
  { id: "changes", nameTh: "แก้ไขบริษัท", nameEn: "Corporate Changes" },
  { id: "shutdown", nameTh: "เลิกบริษัท", nameEn: "Wind-down / Liquidation" },
  { id: "compliance", nameTh: "บัญชีภาษี Compliance", nameEn: "Accounting & Compliance" },
] as const;

// ── Nationalities (15 investor origin contexts) ───────────────────────────
export interface CorporateNationality {
  slug: string;
  nameTh: string;
  nameEn: string;
  notes: string;
  specialTreaty?: string;
}

export const CORPORATE_NATIONALITIES: CorporateNationality[] = [
  { slug: "us", nameTh: "อเมริกา", nameEn: "United States", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก", specialTreaty: "US-Thai Treaty of Amity 1966" },
  { slug: "japan", nameTh: "ญี่ปุ่น", nameEn: "Japan", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "china", nameTh: "จีน", nameEn: "China", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "singapore", nameTh: "สิงคโปร์", nameEn: "Singapore", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "australia", nameTh: "ออสเตรเลีย", nameEn: "Australia", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "korea", nameTh: "เกาหลีใต้", nameEn: "Korea", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "germany", nameTh: "เยอรมัน", nameEn: "Germany", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "uk", nameTh: "อังกฤษ", nameEn: "United Kingdom", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "france", nameTh: "ฝรั่งเศส", nameEn: "France", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "india", nameTh: "อินเดีย", nameEn: "India", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "russia", nameTh: "รัสเซีย", nameEn: "Russia", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "uae", nameTh: "UAE", nameEn: "United Arab Emirates", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "hong-kong", nameTh: "ฮ่องกง", nameEn: "Hong Kong", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "taiwan", nameTh: "ไต้หวัน", nameEn: "Taiwan", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
  { slug: "netherlands", nameTh: "เนเธอร์แลนด์", nameEn: "Netherlands", notes: "ตรวจสัญชาติผู้ลงทุน ผู้ควบคุม โครงสร้างผู้ถือหุ้นและกิจกรรมจริงก่อนประเมินสิทธิ เอกสารต่างประเทศต้องตรวจเส้นทางแปลและรับรองตามประเทศผู้ออก" },
];

// ── Business zones (12 Bangkok + Greater Bangkok + provincial hubs) ───────
export interface CorporateZone {
  slug: string;
  nameTh: string;
  nameEn: string;
  region: "bkk-cbd" | "bkk-fringe" | "gtr-bkk" | "eec" | "regional";
  highlights: string;
}

export const CORPORATE_ZONES: CorporateZone[] = [
  { slug: "silom", nameTh: "สีลม-สาทร", nameEn: "Silom-Sathorn", region: "bkk-cbd", highlights: "financial CBD, บริษัทกฎหมาย, MNC HQ" },
  { slug: "sukhumvit", nameTh: "สุขุมวิท-อโศก", nameEn: "Sukhumvit-Asoke", region: "bkk-cbd", highlights: "expat business, hospitality, consulting" },
  { slug: "rama9", nameTh: "พระราม 9-รัชดา", nameEn: "Rama 9-Ratchada", region: "bkk-cbd", highlights: "new CBD, tech offices, IT startups" },
  { slug: "phaya-thai", nameTh: "พญาไท-อารีย์", nameEn: "Phaya Thai-Ari", region: "bkk-cbd", highlights: "creative agencies, media, healthtech" },
  { slug: "bangna", nameTh: "บางนา-สำโรง", nameEn: "Bangna-Samrong", region: "bkk-fringe", highlights: "logistics, e-commerce warehouse, trading" },
  { slug: "ladprao", nameTh: "ลาดพร้าว-รัชดา-เหลืองอมร", nameEn: "Ladprao-Ratchada", region: "bkk-fringe", highlights: "SME, service business, franchise HQ" },
  { slug: "chatuchak", nameTh: "จตุจักร-หลักสี่", nameEn: "Chatuchak-Laksi", region: "bkk-fringe", highlights: "SMEs, wholesale, gov contractor" },
  { slug: "nonthaburi", nameTh: "นนทบุรี", nameEn: "Nonthaburi", region: "gtr-bkk", highlights: "IT parks, government-adjacent, real estate" },
  { slug: "samut-prakan", nameTh: "สมุทรปราการ", nameEn: "Samut Prakan", region: "gtr-bkk", highlights: "industrial, logistics near BKK airport, factories" },
  { slug: "chonburi", nameTh: "ชลบุรี (EEC)", nameEn: "Chonburi (EEC)", region: "eec", highlights: "ตรวจเงื่อนไข EEC รายโครงการ, Amata City, automotive, electronics" },
  { slug: "rayong", nameTh: "ระยอง (EEC)", nameEn: "Rayong (EEC)", region: "eec", highlights: "ตรวจเงื่อนไข EEC รายโครงการ, petrochemical, U-Tapao aviation" },
  { slug: "chiang-mai", nameTh: "เชียงใหม่", nameEn: "Chiang Mai", region: "regional", highlights: "creative economy, agri-tech; สิทธิ BOI ต้องตรวจตามโครงการ" },
];

export type { CorporateService as CorporateServiceType };
